import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError, of, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RouteAuthService } from '../menu/route-auth.service';
import { MainService } from '../main/main.service';
import { DatePipe } from '@angular/common';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ContractDialogComponent } from 'src/app/pages/contract/contract-modal/contract-modal.component';
import { GlobalFilterService } from './global-filter.service';
import { getUserProfile, getUserProfiles } from 'src/app/core/session';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  headers: any = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': '*/*' });
  private zipRequestCache: { [key: number]: Observable<any> } = {};
  private zipCache: { [key: number]: any } = {};
  private financeReset = new Subject<boolean>();
  profile: any;

  constructor(
    public routerAuth: RouteAuthService,
    public http: HttpClient,
    private dialog: MatDialog,
    public mainService: MainService,
    public datepipe: DatePipe,
    public globalFilterService: GlobalFilterService,
    public router: Router
  ) {
  }

  getZipcode(params: any) {
    if (this.zipCache[params.zipcode]) {
      return of(this.zipCache[params.zipcode]);
    }
    else if (this.zipRequestCache[params.zipcode]) {
      return this.zipRequestCache[params.zipcode];
    }
    else {
      this.zipRequestCache[params.zipcode] = this.http.post<any>(`https://apilivev2.denefits.com/business/get_zipcode`, params, { headers: this.headers })
        .pipe(
          map((data: any) => {
            this.zipCache[params.zipcode] = data;
            return this.zipCache[params.zipcode];
          }),
          catchError((error: any) => {
            return throwError(error);
          })
        );
    }
    return this.zipRequestCache[params.zipcode]
  }

  resetFinanceFlow(flag: boolean) {
    this.financeReset.next(flag);
    this.clearLocalStorage();
  }

  getFinanceFlowState(): Observable<any> {
    return this.financeReset.asObservable();
  }

  openIncreasePPACHLimitPopup(doctor_id, settings) {
    let data = {
      access_token: localStorage.getItem('token'),
      doctor_id: doctor_id
    };
    this.mainService.api(data, `get_business_auth_data`, false)
      .subscribe(doctorAccountDetail => {
        if (doctorAccountDetail.auth_bank_status == 'not_added') {
          this.dialog.open(SimpleDialogComponent, {
            width: '540px',
            disableClose: true,
            panelClass: 'simpleDialog',
            data: {
              type: 35,
              title: 'Business Verification',
              send_data: {
                paymentInfo: settings,
                doctor_id: doctor_id,
                acc_details: doctorAccountDetail
              }
            }
          })
        } else {
          this.callYouBackModal('5');
        }
      });
  }
  callYouBackModal(selected_option?) {
    let userInfo = getUserProfiles();
    var firstName = userInfo[0].enterprise_first_name ? userInfo[0].enterprise_first_name : userInfo[0].doctor_first_name;
    var lastName = userInfo[0].enterprise_last_name ? userInfo[0].enterprise_last_name : userInfo[0].doctor_last_name;
    var userphonenumber = userInfo[0].enterprise_mobile ? userInfo[0].enterprise_mobile : userInfo[0].doctor_mobile;
    var email = userInfo[0].enterprise_email ? userInfo[0].enterprise_email : (userInfo[0].agent_email ? userInfo[0].agent_email : userInfo[0].doctor_email);
    var date = new Date();
    var todayDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');

    /*  */
    var hr = date.getHours();
    var min = date.getMinutes();
    hr = hr % 12;
    hr = hr ? hr : 12; // the hour '0' should be '12'
    var min1 = min < 10 ? '0' + min : min;
    var strTime = hr + ':' + min1 + ' ';

    /* Call Req Time limit */
    let time = new Date().getTimezoneOffset();
    let hours = Math.abs(Math.trunc(time / 60));
    let minutes = ("0" + time % 60).slice(-2);
    let user_timezone = '';
    if (time > 0) {
      user_timezone = "-" + hours + minutes;
    } else {
      user_timezone = "+" + hours + minutes;
    }
    let data = {
      access_token: localStorage.getItem('token'),
      request_date: todayDate,
      timezone: user_timezone
    }
    this.mainService.api(data, 'call_req_time_limits', true)
      .subscribe((requestTimeLimit: any) => {
        /* Call-back Reasons */
        this.mainService.api(data, 'fetch_all_callback_reasons', true)
          .subscribe((callReasonList: any) => {
            let confirmDialogRef = this.dialog.open(ContractDialogComponent, {
              width: '500px',
              panelClass: 'rightFullDialog',
              data: {
                title: 'Request Callback',
                action: 'Send',
                actionClass: 'delete-button',
                type: 25,
                send_data: {
                  name: firstName + ' ' + lastName,
                  phone: userphonenumber ? userphonenumber.replace(/(.*)-/, "") : '',
                  email: email,
                  reason: callReasonList.data,
                  message: '',
                  priority: '',
                  call_req_date: requestTimeLimit.selected_date,
                  call_req_time: strTime,
                  csr_req_tz: user_timezone,
                  csr_req_tz_name: 'PST',
                  selected_option: selected_option
                }
              }
            });
            confirmDialogRef.afterClosed().subscribe(result => {
              if (result == 1) {
                this.mainService.customPopups('Thank You! Our representative will contact you to handle your request shortly.', 0);
              }
            });
          });
      });
  }

  openWriteToUs(doctor_id) {
    this.dialog.open(ContractDialogComponent, {
      width: '500px',
      panelClass: 'rightFullDialog',
      data: {
        type: 40,
        title: 'Write to Denefits',
        send_data: {
          doctor_id: doctor_id
        }
      }
    })
  }

  locations = [];
  getSelectedBusiness(link?, need_result?, val?) {
    let user_info = getUserProfile();
    if (user_info.role_id != 4) {
      if (!this.locations || this.locations.length == 0) {
        const data: any = {
          access_token: localStorage.getItem('token'),
          limit: 1000,
          case: 3,
          search_string: ''
        };
        this.mainService.api(data, `get_all_locations`, false, 'object')
          .subscribe(response => {
            if(response && response.is_error == 1 && response.tracking_id == '9371b' && user_info.role_id == 1) {
              this.mainService.customPopups('Please add a location/business to access Denefits features.', 1);
            }
            if (response.is_error == 0) {
              this.locations = response.data;
              this.mainService.getAllLocations.next(this.locations);
              if (this.locations && this.locations.length > 0) {
                // if (response.count == 1) {
                  // this.mainService.getFinanceValues(this.locations[0].doctor_id);
                // } else {
                  this.openPopup(link, val);
                // }
                this.locations.forEach(location => {
                  if (!location.location_name && !location.practice_name) {
                    location.practice_name = location.doctor_first_name + ' ' + location.doctor_last_name;
                  }
                })
              }
            }
          });
      } else {
        if (this.locations.length == 1) {
          this.getNextData(this.locations[0], link, need_result,val);
        } else {
          this.openPopup(link, need_result,val);
        }
      }
    } else {
      this.getNextData(user_info, link, need_result,val)
    }
  }

  openPopup(link, need_result,val?) {
    let user_info = getUserProfile();
    if (user_info.role_id != 4) {

      let userInfo = this.globalFilterService.getFilterObj('location');

      if(userInfo) {
        // let userData;
        // userData = this.locations.find((loc)=>{
        //   if(loc.doctor_id == userInfo[0].id) {
        //      return loc;
        //   }
        // });

        if (userInfo && userInfo.name != 'All') {
          if (need_result instanceof Function) {
            this.mainService.getLocationFilter.next(userInfo);
            need_result(userInfo);
            return;
          }

          if (link) {
            this.mainService.getLocationFilter.next(userInfo);
            this.getRedirect(link, userInfo);
            return;
          }
        }
      }

      let dialogref = this.dialog.open(SimpleDialogComponent, {
        panelClass: 'simpleDialog',
        data: {
          type: 215,
          send_data: {
          }
        }
      })
      dialogref.afterClosed().subscribe(result => {
        if (result) {
          localStorage.removeItem('doctorSettings');
          localStorage.removeItem('prepaidCardSettings');
          this.getNextData(result, link, need_result,val);
        }
      });
    } else {
      this.getNextData(user_info, link, need_result,val)
    }
  }

  getNextData(loc, link, need_result, val) {
    let user_info = getUserProfile();
    loc.type = 'location';
    loc.id = loc.doctor_id;
    loc.financeMode = val;
    let data = {
      access_token: localStorage.getItem('token'),
      doctor_id: loc.id,
    }
    if (user_info.role_id != 4) {
      if(loc.id) {
        this.mainService.api(data, `switch_doctor`, false)
        .subscribe(response => {
          this.mainService.init()
          this.mainService.getLocationFilter.next(loc);
          this.globalFilterService.setGlobalFilter(loc);
          this.mainService.getFinanceValues(loc.doctor_id,null, (finance)=>{
          if (loc) {
            let filterObj = {
              id: loc.doctor_id,
              ind_id: loc.ind_id,
              bsa_form_type: loc.bsa_form_type,
              practice_name: loc.practice_name
            }
            let doctorSettings = localStorage.getItem('doctorSettings');
            if (need_result && doctorSettings) {
              need_result(loc);
            } else if (link) {
              localStorage.setItem('currentLoc', JSON.stringify(filterObj));
              if(response.profile && response.profile[0].can_finance){
                this.getRedirect(link, loc);
              } else if(link && response.profile[0].role_id == 1 && finance.data.can_finance) {
                if(link == 'app/process-payment/payment' && finance.data.pp_restricted) return;
                this.getRedirect(link, loc);
              } else {
                setTimeout(() => {
                  this.router.navigate(['/app/finance-customer']);
                }, 500);
              }
            }
          }
          });
        })
      } else {
        this.mainService.init()
        this.mainService.getLocationFilter.next(loc);
        this.globalFilterService.setGlobalFilter(loc);
      }
    } else {
      this.mainService.getLocationFilter.next(loc);
      this.globalFilterService.setGlobalFilter(loc);
      if (loc) {
        let filterObj = {
          id: loc.doctor_id,
          ind_id: loc.ind_id,
          bsa_form_type: loc.bsa_form_type,
          practice_name: loc.practice_name
        }
        if (need_result) {
          need_result(loc);
        } else if (link) {
          localStorage.setItem('currentLoc', JSON.stringify(filterObj));
          if (link == '/app/global-settings') {
            this.router.navigate(['/app/global-settings'], { queryParams: { locId: loc.doctor_id } });
          } else {
            if ((window.location.pathname == '/app/finance-customer') && (link == window.location.pathname)) {
              this.mainService.getFinanceValues(loc.doctor_id);
            }
            this.router.navigate([link]);
          }
          if (link == '/app/finance' || link == '/app/process-payment/payment' || link == '/app/accounts-receivable/send-invoice') {
            this.mainService.getFinanceValues(loc.doctor_id);
          }
        }
      }
    }
  }

  getRedirect(link, loc) {
    if (link == '/app/global-settings') {
      this.router.navigate(['/app/global-settings'], { queryParams: { locId: loc.id } });
    } else {
      if ((window.location.pathname == '/app/finance-customer') && (link == window.location.pathname)) {
        this.mainService.getFinanceValues(loc.id);
      }
      this.router.navigate([link]);
    }
    if (link == '/app/finance' || link == '/app/process-payment/payment' || link == '/app/accounts-receivable/send-invoice') {
      this.mainService.getFinanceValues(loc.id);
    }
  }

  clearLocalStorage() {
    localStorage.removeItem('interestrate');
    localStorage.removeItem('arViewMode');
    localStorage.removeItem('availableTerms');
    localStorage.removeItem('breakdown');
    localStorage.removeItem('contractDetails');
    localStorage.removeItem('contractPlan');
    localStorage.removeItem('contractType');
    localStorage.removeItem('customNoFeeAvailableMonth');
    localStorage.removeItem('customerCards');
    localStorage.removeItem('docId');
    localStorage.removeItem('doctorId');
    localStorage.removeItem('doctor_balance');
    localStorage.removeItem('doctorsCardList');
    localStorage.removeItem('downpayment');
    localStorage.removeItem('emailId');
    localStorage.removeItem('estimateServAmt');
    localStorage.removeItem('existingUserData');
    localStorage.removeItem('filteredArray');
    localStorage.removeItem('finalContractId');
    localStorage.removeItem('financeOption');
    localStorage.removeItem('fixed_flat_fee');
    localStorage.removeItem('hundres_cards');
    localStorage.removeItem('initialPayment');
    localStorage.removeItem('interestrate');
    localStorage.removeItem('isExistingUser');
    localStorage.removeItem('isSendPlans');
    localStorage.removeItem('noFeePaymentCards');
    localStorage.removeItem('patientId');
    localStorage.removeItem('removeIconHide');
    localStorage.removeItem('retainemployer_zip');
    localStorage.removeItem('retainUserZipCode');
    localStorage.removeItem('selectedPlan');
    localStorage.removeItem('selected_plan_index');
    localStorage.removeItem('singalAmount');
    localStorage.removeItem('stepback');
    localStorage.removeItem('strData');
    localStorage.removeItem('switchUserForm');
    localStorage.removeItem('totalServAmt');
    localStorage.removeItem('validateData');
    localStorage.removeItem('viewMode');
    localStorage.removeItem('send_data');
    localStorage.removeItem('proposalDetails');
    localStorage.removeItem('ppViewMode');
    localStorage.removeItem('customerDetail');
    localStorage.removeItem('customerReatinedZip');
    localStorage.removeItem('userdata');
    localStorage.removeItem('downpayemnt_object');
    localStorage.removeItem('total_payable_today');
    localStorage.removeItem('selectedPlans');
    this.locations = [];
  }
  clearLeadsData(){
    localStorage.removeItem('lead_application');
  }
}
